import { useState } from 'react';
import { navLinks } from '@/mocks/home';

export default function TopBar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [query, setQuery] = useState('');

  return (
    <header className="sticky top-0 z-50 w-full">
      <div className="bg-foreground-950 text-background-100">
        <div className="mx-auto flex h-9 w-full max-w-[1400px] items-center justify-between px-4 text-xs md:px-6">
          <div className="flex items-center gap-4">
            <span className="flex items-center gap-1.5">
              <i className="ri-live-line text-primary-400" />
              全网瓜料实时监控中
            </span>
            <span className="hidden text-background-400 sm:inline">2026 年 09 月 11 日 · 周五</span>
          </div>
          <div className="flex items-center gap-4">
            <span className="hidden items-center gap-1.5 text-background-300 sm:flex">
              <i className="ri-fire-line text-accent-400" />
              今日新增爆料 128 条
            </span>
            <a href="#today" className="cursor-pointer transition-colors hover:text-accent-400">
              登录
            </a>
            <a href="#today" className="cursor-pointer transition-colors hover:text-accent-400">
              注册
            </a>
          </div>
        </div>
      </div>

      <div className="border-b border-background-200 bg-background-50/95 backdrop-blur">
        <div className="mx-auto flex h-16 w-full max-w-[1400px] items-center gap-4 px-4 md:px-6">
          <a href="#today" className="flex shrink-0 cursor-pointer items-center gap-2.5">
            <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-fire-fill text-2xl" />
            </span>
            <h1 className="font-heading text-xl font-black tracking-tight text-foreground-950 md:text-2xl">黑料大瓜</h1>
          </a>

          <nav className="hidden flex-1 items-center justify-center gap-1 lg:flex">
            {navLinks.map((link) => (
              <a
                key={link.id}
                href={`#${link.id}`}
                className="cursor-pointer whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-primary-50 hover:text-primary-600"
              >
                {link.label}
              </a>
            ))}
          </nav>

          <div className="ml-auto flex items-center gap-2 md:gap-3">
            <div className="hidden items-center gap-2 rounded-md border border-background-300 bg-background-100 px-3 py-2 md:flex">
              <i className="ri-search-line text-base text-foreground-500" />
              <input
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                placeholder="搜你想吃的瓜"
                className="w-32 bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-500 lg:w-44"
              />
            </div>
            <a
              href="#today"
              className="hidden cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 md:flex"
            >
              <i className="ri-megaphone-line" />
              我要爆料
            </a>
            <button
              type="button"
              onClick={() => setMobileOpen((v) => !v)}
              aria-label="打开菜单"
              className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md border border-background-300 text-foreground-800 lg:hidden"
            >
              <i className={mobileOpen ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'} />
            </button>
          </div>
        </div>

        {mobileOpen && (
          <div className="border-t border-background-200 bg-background-50 px-4 py-4 lg:hidden">
            <div className="mb-3 flex items-center gap-2 rounded-md border border-background-300 bg-background-100 px-3 py-2">
              <i className="ri-search-line text-base text-foreground-500" />
              <input
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                placeholder="搜你想吃的瓜"
                className="w-full bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-500"
              />
            </div>
            <div className="grid grid-cols-2 gap-2">
              {navLinks.map((link) => (
                <a
                  key={link.id}
                  href={`#${link.id}`}
                  onClick={() => setMobileOpen(false)}
                  className="cursor-pointer rounded-md bg-background-100 px-3 py-2.5 text-sm font-medium text-foreground-800"
                >
                  {link.label}
                </a>
              ))}
            </div>
            <a
              href="#today"
              className="mt-3 flex cursor-pointer items-center justify-center gap-1.5 rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50"
            >
              <i className="ri-megaphone-line" />
              我要爆料
            </a>
          </div>
        )}
      </div>
    </header>
  );
}